import { useMutation } from "@tanstack/react-query";
import { sendRating } from "@src/entities/rating/api/request/sendRating";
import { useNotificationStore } from "@src/shared/components/Notification";

export const useSendRating = () => {
  const { showAlert } = useNotificationStore();
  const query = useMutation({
    mutationFn: sendRating,
    onError: (error) => {
      showAlert(error.message, "error");
    },
  });
  return query;
};
